import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { stopPropagation } from '../../../utils/events'
import ButtonComponent, { BUTTON_HEIGHT_24, ButtonIcon } from '../../Button'
import { FloatingTooltip } from '../../Floating'
import { ICON_HEIGHT_16 } from '../../Icon'
import Text from '../../Text'

import * as styles from './FilterTemplateListItemContent.module.css'

import EditIcon from '../../../icons/edit.svg'
import LockIcon from '../../../icons/lock.svg'

function FilterTemplateListItemContent({
  isFocused,
  isHovered,
  text,
  value,
  onCloseMenu,
  onEdit,
}) {
  const {
    created_by: { fullname },
    is_public: isPublic,
    permissions: { can_edit: canEdit },
  } = value

  const { t } = useTranslation()

  function handleEdit(event) {
    stopPropagation(event)

    onEdit(value)
    onCloseMenu()
  }

  const mods = {
    [styles.hover]: isFocused || isHovered,
  }

  const textClassName = classNames(styles.text, mods)

  const extraTextClassName = classNames(styles.extraText, mods)

  const lockIconClassName = classNames(styles.lockIcon, mods)

  const editButtonClassName = classNames(styles.editButton, mods)

  return (
    <>
      <div className={styles.itemContent}>
        {isPublic ? null : (
          <ButtonIcon
            Icon={LockIcon}
            className={lockIconClassName}
            height={ICON_HEIGHT_16}
            tooltip={t('Select.PrivateTamplateTooltip')}
          />
        )}
        <div className={styles.textContainer}>
          <FloatingTooltip content={text}>
            <Text className={textClassName}>{text}</Text>
          </FloatingTooltip>
          {canEdit ? null : (
            <Text isSecondary className={extraTextClassName}>{`${t(
              'Common.ByPerson',
              {
                name: fullname,
              }
            )}`}</Text>
          )}
        </div>
      </div>
      {canEdit && onEdit ? (
        <ButtonComponent.Contained
          isLight
          beforeIconProps={{ Icon: EditIcon }}
          className={editButtonClassName}
          height={BUTTON_HEIGHT_24}
          tooltip={t('Select.EditFilterTemplateTooltipKey')}
          tooltipPlacement='top'
          onClick={handleEdit}
        />
      ) : null}
    </>
  )
}

export default FilterTemplateListItemContent
